export default __webpack_public_path__ + "area-info.png";